<template>
  <div class="container">
    <commonTip
      :iType="0"
      :titleStr="tipTitle"
      v-if="isShowTip"
      @tipConfirm="tipSureAction"
    ></commonTip>
    <div class="log_container">
      <div class="log_container_left"></div>
      <div class="log_container_right">
        <div class="log_container_right_header">
          <span class="log_container_right_title">智贝通-客服机器人</span>
          <div class="imgs">
            <img
              v-if="bind === false && QRcode === false"
              src="../../static/login/log_qrcode1.png"
              style="height: 94px"
              class="img_board"
              @click="wechatLogin"
            />
            <img
              v-if="bind === false && QRcode === true"
              src="../../static/login/log_keyboard1.png"
              style="height: 94px"
              class="img_board1"
              @click="inputLogin"
            />
          </div>
        </div>

        <!-- <el-input
          v-if="!QRcode "
          v-model="station"
          class="log_container_input input1"
          placeholder="请输入站点"
        ></el-input> -->
        <!-- 站点输入 -->

        <div style="display: flex;justify-content: center;align-items: center;">
          <el-select
          v-model="station"
          placeholder="请输入站点"
          spellcheck="false"
          v-if="!QRcode"
          class="log_selection"
          filterable
          @input.native="nativeChangeAccount(0, $event)"
          @change="handleGetUsername"
          @blur="
            ($event) => {
              selectBlur(0, $event);
            }
          "
        >
          <el-option
            v-for="item in stationsAndNames"
            :key="item.stationsOptions"
            :label="item.stationsOptions"
            :value="item.stationsOptions"
          >
          </el-option>
        </el-select>
        </div>
        <div style="display: flex;justify-content: flex-end;align-items: center;width: 100%;height: 35px;margin-right: 60px;">
          <span style="font-size: 12px;color: red;" v-if="station !== ''"  @click="delStation">删除该站点</span>
        </div>

        <!-- 账号输入 -->
        <el-select
          v-model="name"
          placeholder="账号输入"
          spellcheck="false"
          @input.native="nativeChangeAccount(1, $event)"
          @change="changeUser"
          v-if="!QRcode"
          filterable
          @blur="
            ($event) => {
              selectBlur(1, $event);
            }
          "
          class="log_selection input2"
          style="margin-top: 0px;"
        >
          <el-option
            v-for="item in nameOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <!-- <el-input
          v-if="!QRcode"
          v-model="name"
          class="log_container_input input2"
          placeholder="请输入账号"
        ></el-input> -->
        <el-input
          v-if="!QRcode"
          type="password"
          v-model="password"
          class="log_container_input input2"
          @keydown.native="handleClickEnterKey"
          placeholder="请输入密码"
          spellcheck="false"
          @change="changePassword"
        ></el-input>

        <div v-if="!QRcode" class="log_button" @click="login">
          <!-- <img src="../../static/login/log_buuton.png" /> -->
        </div>
        <div v-if="!QRcode" class="log_container_right_footer">
          <el-checkbox
            class="log_container_right_footer_left"
            v-model="remember"
            >7天内记住密码</el-checkbox>
          <div class="log_container_right_footer_right" @click="forgetpassword">
            忘记密码？
          </div>
        </div>

        <div class="weixin" v-if="bind === true">
          <div
            style="
              margin-bottom: 15px;
              font-size: 16px;
              color: #333333;
              font-weight: 600;
            "
          >
            请输入账号进行绑定
          </div>
          <el-input
            v-model="name"
            autocomplete="off"
            placeholder="请输入用户名"
            style="width: 100%; margin-bottom: 20px"
            id="webid"
            @keyup.enter.native="confirmWebid"
          >
          </el-input>
          <el-input
            v-model="password"
            show-password
            autocomplete="off"
            placeholder="请输入密码"
            style="width: 100%; margin-bottom: 20px"
            id="webid"
            @keyup.enter.native="confirmWebid"
          >
          </el-input>
          <div
            style="
              margin-bottom: 20px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            "
          >
            <el-input
              placeholder="请输入内容"
              v-model.trim="Vcode"
              style="width: 70%; float: left"
            ></el-input>
            <el-button
              type="primary"
              style="width: 20%"
              v-show="show"
              @click="getCode"
              >获取验证码</el-button
            >
            <el-button
              type="primary"
              style="width: 20%"
              v-show="!show"
              :disabled="true"
              >{{ count }} s
            </el-button>
          </div>
          <el-button
            type="primary"
            style="
              height: 46px;
              margin-top: 30px;
              font-size: 16px;
              letter-spacing: 1px;
            "
            @click="bindWeChat"
            >立即绑定</el-button
          >
        </div>

        <div
          class="qrcode"
          id="login_QR"
          v-if="QRcode === true && bind === false"
        >
          <!-- style="width: 400px;height: 400px;" -->

          <div
            style="
              width: 300px;
              color: #6a6a6a;
              margin-bottom: 7px;
              text-align: center;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
            "
          >
            站点：{{ station }}
          </div>
          <div>
            <!-- qrData.qrCodeUrl -->
            <img :src="qrData.qrCodeUrl" style="width: 300px; height: 300px" />
            <div
              style="
                width: 300px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
                text-align: center;
              "
            >
              请使用微信扫描公众号二维码进行登录
            </div>
            <div
              v-if="qrCodeTime === false"
              style="
                width: 300px;
                height: 300px;
                position: absolute;
                background: rgba(0, 0, 0, 0.7);
                margin-top: -332px;
              "
            >
              <div
                style="
                  z-index: 99;
                  color: white;
                  font-weight: bold;
                  line-height: 150px;
                  text-align: center;
                "
              >
                二维码失效，点击重新获取
              </div>
              <el-button
                style="z-index: 99; margin-left: 100px"
                type="primary"
                icon="el-icon-refresh"
                @click="refreshQRcode"
                >刷新</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="setPassword == true">
      <FGpassword
        @confirm="confirmSet"
        @close="closeSet"
        :showSuccess="showSuccess"
        :userName="name"
        :phoneNumber="phoneNumber"
        :code="showCode"
        @clickCancle="clickCancle"
        :password="showPassword"
      >
      </FGpassword>
    </div>
    <div v-if="MessageCode == true">
      <MsgCode
        @ReSend="ReSend"
        @successed="successed"
        @close="close"
        :password="password"
        :addStation="addStation"
        :username="name"
        :equNo="equNo"
        :station="station"
        :remember="remember"
        :version="version"
      ></MsgCode>
    </div>

    <div class="filings">
      &copy;2020-2023 {{ copyrightURL }} 版权所有 ICP证：<a
        href="https://beian.miit.gov.cn/"
        target="_blank"
      >
        {{ filingName }}</a
      >
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import MsgCode from "../components/MessageCodeBox/index.js";
import commonTip from "../components/commonTip.vue";
// import config from "../utils/electronConfig.js";
import FGpassword from "../components/ForgetPasswordBox/index.js";
import Cookies from "js-cookie";

// import {
// 	getCookie
// 	setCookie,
// 	removeCookie
// } from '../utils/electronCookie.js'

export default {
  data() {
    return {
      name: "",
      station: "",
      password: "",
      remember: false,
      captcha: "",
      version: process.env.VUE_APP_VERSION,
      equNo: "",
      smsValidate: true,
      setPassword: false,
      showCode: false,
      showPassword: false,
      showSuccess: false,
      copyrightURL: "",
      filingName: "",
      username: true,
      NewUser: false,
      SetPassword: false,
      success: false,
      MessageCode: false,

      passwordChecked: false,
      SMSCode: "1234",

      form: {
        password: "",
        newPassword: "",
      },
      // rules: {
      // 	password: [{
      // 		validator: validatePass,
      // 		trigger: 'blur'
      // 	}],
      // 	newPassword: [{
      // 		validator: validatePass2,
      // 		trigger: 'blur'
      // 	}]
      // },
      isShowTip: false,
      tipTitle: "",
      stationItems: [],
      QRcode: false,
      bind: false,
      appid: "wxaeaff8dd52ca7a28",
      redirect_uri: "https%3A%2F%2Fmedibot.online%2Fweixin%2Fcallback",
      scope: "snsapi_login",
      state: "STATE",
      href: "",
      code: "https://open.weixin.qq.com",

      qrData: "", // 获取二维码
      qrCodeTime: true,
      Vcode: "",
      timer: "",
      qrState: "",
      qrResData: "", // 查询二维码状态的返回值
      show: true,
      count: "",
      timers: null,
      cookiePassword: "",
      // 站点账号
      stationsAndNames: [
        {
          stationsOptions: "",
          namesOptions: [],
        },
      ],
      nameOptions: [],
      loginType: "normal",
      electronCookies: [],
    };
  },
  components: {
    MsgCode,
    commonTip,
    FGpassword,
    // wxlogin,
  },
  async beforeRouteEnter(to, from, next) {
    //从首页退出，正常显示登录界面 to:index from:home
    if (to.name === "index" && from.name === "home") {
      next((vm) => {
        const logout = vm.util.getLoginTip();
        if (logout === "0") {
          next();
          return;
        }
      });
    }
    // else if (to.name === 'index' && from.name === null) {
    // 	//直接点击登录界面的链接，检测是否是免登录用户 to:index from:null
    // 	next (async vm => {
    // 		const netState = vm.util.getLocalNetTip()
    // 		console.log('index beforeRouteEnter netstate = ', netState)
    // 		if (netState === '2') {
    // 			next()

    // 			return
    // 		}

    // 		let isFree = vm.util.getLocalFree()
    // 		console.log('index beforeRouteEnter isFree = ', isFree)
    // 		if (isFree === '1') {
    // 			let account = vm.util.getLocalAccount()
    // 			var loginApi = '/manager/user/pass/isChenkedLoginUser'
    // 			const response = await vm.util.postRequest({
    // 				url: loginApi,
    // 				method: 'POST',
    // 				data: {
    // 					loginName:account.loginName,
    // 					password:account.password,
    // 					isLogFree: true
    // 				}
    // 			})

    // 			console.log('index beforeRouteEnter response = ', response)
    // 			if (response.resultCode === '10000') {
    // 				const map = response.data.map
    // 				if (map !== null) {
    // 					const code = map.code
    // 					if (code === '0') {
    // 						//code -1 超过10天，需重新登录
    // 						//code 0 未超过10天，可直接跳到home界面
    // 						vm.util.setLoginTip(1)
    // 						vm.util.setLocalToken(response.token)

    // 						next({ path: '/home' })
    // 					}
    // 				}

    // 			} else {
    // 				vm.$message.error(response.desc)
    // 			}
    // 		}
    // 	})
    // }

    next();
  },
  created() {
    this.getDomainName();
    this.util.setLoginTip(0);
    const iWsState = this.util.getLocalWsState();
    let userAgent = navigator.userAgent.toLowerCase();
    let ipc = null;
    if (userAgent.indexOf("electron/") != -1) {
      ipc = this.$electron.ipcRenderer;
    }
    if (ipc !== null) {
      console.log("cookie验证 electron环境 获取cookie");
      ipc.send("getCookie");
      ipc.on("tio_session", (event, args) => {
        console.log("接收到主进程的消息", args);
        this.electronCookies = args;
      });
      ipc.on("logout", async (event, args) => {
        console.log("接收到主进程的消息 点击托盘退出", args);
        var api = "/manager/user/logOut";
        setTimeout(function () {
          console.log("进入退出图标 程序的流程");
          ipc.send("logoutProgram", true);
        }, 0);
        try {
          await this.util.postRequest({
            url: api,
            method: "POST",
          });
          console.log("请求发送成功");
        } catch (error) {
          console.log("托盘退出报错");
        }
      });
    }
    if (this.$store.state.authority.type3Data !== null) {
      if (iWsState === "3" || iWsState === "4" || iWsState === "5") {
        this.util.pauseFlickerAudio();
        if (iWsState === "3") {
          let ipstr = "";
          ipstr = this.$store.state.authority.type3Data.data.ip;
          this.tipTitle = "你已被" + ipstr + "踢出 ！";

          this.tipTitle = this.$store.state.authority.type3Data.data.content;
          this.util.setWsState("0");
          this.isShowTip = true;
          this.$store.state.authority.type3Data = null;
          this.util.pauseFlickerAudio();
          this.util.setLoginTip(0);
          localStorage.setItem("token", null);
        } else if (iWsState === "4") {
          this.tipTitle = "token已过期，请重新登录！";
          this.isShowTip = true;
          this.util.setWsState("0");
          this.util.pauseFlickerAudio();
          this.util.setLoginTip(0);
          localStorage.setItem("token", null);
        } else if (iWsState === "5") {
          this.tipTitle = "缓存被清除，请重新登录！";
          this.isShowTip = true;
          this.util.setWsState("0");
          this.util.pauseFlickerAudio();
          this.util.setLoginTip(0);
          localStorage.setItem("token", null);
          // closeWebsocket()
        }
      } else if (
        iWsState === "0" &&
        this.$store.state.authority.type3Data.type == "3"
      ) {
        let ipstr = "";
        ipstr = this.$store.state.authority.type3Data.data.ip;
        this.tipTitle = "你已被" + ipstr + "踢出 ！";
        this.tipTitle = this.$store.state.authority.type3Data.data.content;
        this.isShowTip = true;
        this.$store.state.authority.type3Data = null;
        this.util.pauseFlickerAudio();
        this.util.setLoginTip(0);
        this.util.setWsState("0");
        localStorage.setItem("token", null);
      }
    } else {
      if (iWsState === "4") {
        this.tipTitle = "token已过期，请重新登录！";
        this.isShowTip = true;
        this.util.pauseFlickerAudio();
        this.util.setLoginTip(0);
        this.util.setWsState("0");
        localStorage.setItem("token", null);
      }
    }
  },
  mounted() {
    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("electron/") != -1) {
      console.log("index.vue mounted electron 环境");
      const fs = this.$nodeFs;
      let data;
      try {
        data = fs.readFileSync(this.userDirectory, "utf-8");
        if (data) {
          const getData = JSON.parse(data);
          console.log("index.vue mounted 读取文件 成功 mounted:", getData);
          this.stationsAndNames = getData.stationsAndNames;
          console.log("this.stationsAndNames:", this.stationsAndNames);
          this.station = getData.station;
          this.name = getData.username;
          localStorage.setItem("siteObj", JSON.stringify(getData.siteObj));
          localStorage.setItem("username", JSON.stringify(getData.username));
          localStorage.setItem("stations", JSON.stringify(getData.stations));
          localStorage.setItem(
            "stationsAndNames",
            JSON.stringify(getData.stationsAndNames)
          );
          localStorage.setItem(
            "inputHeight",
            JSON.stringify(getData.inputHeight)
          );
          this.$store.state.inputHeight = getData.inputHeight + "px";
        }
      } catch (error) {
        console.log("index.vue 读取文件 失败 mounted error:", error);
      }
    } else {
      this.stationsAndNames =
        JSON.parse(localStorage.getItem("stationsAndNames")) || [];
      this.station =
        this.util.getLocalSite() != null ? this.util.getLocalSite().webId : "";
      this.name = JSON.parse(localStorage.getItem("username"));
    }
    sessionStorage.removeItem("siteObj");
    this.getStations();

    if (this.$nodeFs) {
      const ipc = this.$electron.ipcRenderer;
      ipc.send("closeAllWindow");
    }

    this.handleGetUsername(this.station);
    // this.$store.state.hrefData = {};
    // config.setHrefData(this.$store.state.hrefData);
    this.$nextTick(() => {
      let userAgent = navigator.userAgent.toLowerCase();
      // console.log('getCookie', userAgent.indexOf('electron/') != -1 ? getCookie('cyf') : '')
      setTimeout(() => {
        let count = 0;
        if (userAgent.indexOf("electron/") != -1) {
          console.log("cookie验证 electron 环境");
          for (let i = 0; i < this.electronCookies.length; i++) {
            let item = this.electronCookies[i];
            if (md5(this.name) == item.name) {
              this.cookiePassword = item.value;
              count += 1;
              console.log("cookie验证 该用户有cookie");
              break;
            } else {
              continue;
            }
          }
          if (count == 0) {
            console.log("cookie验证 该用户没有cookie");
            this.cookiePassword = "";
          }
        } else {
          console.log("cookie验证 非electron环境");
          this.cookiePassword = Cookies.get(md5(this.name));
        }
        if (this.cookiePassword != undefined && this.cookiePassword != "") {
          this.remember = true;
          this.password = this.cookiePassword;
          this.loginType = "special";
        } else {
          this.password = "";
          this.cookiePassword = "";
          this.loginType = "normal";
          this.remember = false;
        }
      }, 1000);
    });
  },
  watch: {
    QRcode(val) {
      console.log("index QRcode/qrState value=====>", val, this.qrState);
    },
  },

  methods: {
    // 获取URL一级域名
    getDomainName() {
      const online = "苏ICP备2020058729号-3";
      const cc = "苏ICP备2020058729号-2";
      const url = window.location.hostname.split(".").slice(-2).join(".");
      this.copyrightURL = "苏州贝果智能科技有限公司";
      if (url === "medibot.cc") {
        this.filingName = cc;
      } else if (url === "medibot.online") {
        this.filingName = online;
      } else if (url === "localhost") {
        this.filingName = "测试网址";
      }
    },
    nativeChangeAccount(source, e) {
      if (source === 0) {
        this.station = e.target.value;
        this.station = this.station.trim();
      } else {
        this.name = e.target.value;
        this.name = this.name.trim();
      }
    },
    handleGetUsername(value) {
      console.log("请输入站点：", this.stationsAndNames);
      var index = this.stationsAndNames.findIndex((item) => {
        return item.stationsOptions === value;
      });
      if (index !== -1) {
        this.nameOptions = this.stationsAndNames[index].namesOptions;
      }
    },
    selectBlur(source, $event) {
      if ($event.target.value !== "") {
        if (source === 0) {
          this.station = $event.target.value;
          this.station = this.station.trim();
        } else {
          this.name = $event.target.value;
          this.name = this.name.trim();
        }
      }
    },

    //修改用户名
    changeUser(val) {
      let userAgent = navigator.userAgent.toLowerCase();
      let count = 0;
      if (userAgent.indexOf("electron/") > -1) {
        // 打包版本cookie
        // this.cookiePassword = getCookie(md5(val))
        for (let i = 0; i < this.electronCookies.length; i++) {
          let item = this.electronCookies[i];
          if (md5(this.name) == item.name) {
            count += 1;
            this.cookiePassword = item.value;
            break;
          }
        }
        if (count == 0) {
          this.cookiePassword = "";
        }
      } else {
        this.cookiePassword = Cookies.get(md5(val));
      }

      if (this.cookiePassword != undefined || this.cookiePassword == "") {
        this.password = this.cookiePassword;
      } else {
        this.password = "";
      }
    },

    async login() {
      var api = "/projectchat/project/pass/selectByWebId";
      const response = await this.util.sitePostRequest({
        url: api,
        method: "POST",
        data: {
          webId: this.station.replace(/\s/g, ""),
        },
      });
      if (response.data !== null) {
        //   sessionStorage.setItem("webUrl", response.data.webUrl);
        //存储对象
        var site = JSON.stringify(response.data);

        localStorage.setItem("siteObj", site);
        localStorage.setItem("username", JSON.stringify(this.name));
        //登录
        // this.addStation();
        // this.toLogin();
        this.equCheck();
      } else {
        localStorage.removeItem("siteObj");
        this.$message.error(response.desc);
      }
    },

    async equCheck() {
      var equNoApi = "/manager/equipment/evn/check";
      const response = await this.util.postRequest({
        url: equNoApi,
        method: "POST",
        data: {
          loginName: this.name,
          password:
            this.loginType == "normal" ? md5(this.password) : this.password,
        },
      });
      console.log("equNoApi response========", response);
      if (response.resultCode == 10000) {
        this.equNo = response.data.equNo;
        this.smsValidate = response.data.smsValidate;
        if (this.smsValidate) {
          const res = await this.getSMScode();
          if (res.resultCode === "10000") {
            this.MessageCode = true;
          } else {
            this.$message.error(res.desc);
          }
        } else {
          this.toLogin();
        }
      } else {
        this.$message.error(response.desc);
      }
    },
    handleClickEnterKey(e) {
      console.log(e);
      console.log(e.code);
      if (e.key === "Enter") {
        this.login();
      }
    },
    changePassword(val) {
      console.log("changePasswordVal", val);
      if (this.loginType != "normal") {
        this.loginType = "normal";
      }
    },
    async toLogin() {
      var loginApi = "/manager/user/pass/login";
      console.log("this.loginType :", this.loginType);
      const response = await this.util.postRequest({
        url: loginApi,
        method: "POST",
        data: {
          loginName: this.name,
          version: this.version,
          password:
            this.loginType == "normal" ? md5(this.password) : this.password,
          captcha: this.captcha,
          webId: this.station,
          equNo: this.equNo,
          passwordFlag: this.remember,
        },
      });
      console.log({
        loginName: this.name,
        version: this.version,
        password:
          this.loginType == "normal" ? md5(this.password) : this.password,
        captcha: this.captcha,
        webId: this.station,
        equNo: this.equNo,
        passwordFlag: this.remember,
      });
      if (response.resultCode === "10000") {
        let userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf("electron/") != -1) {
          console.log("index.vue  写入文件 路径" + this.userDirectory);
          try {
            const fs = this.$nodeFs;
            const data = fs.readFileSync(this.userDirectory, "utf-8");
            console.log("index.vue 读取文件 成功 toLogin:");
            const getData = JSON.parse(data);

            const options = {
              siteObj: getData.siteObj,
              username: getData.username,
              station: getData.station,
              stations: getData.stations,
              stationsAndNames: JSON.parse(
                localStorage.getItem("stationsAndNames")
              ),
              inputHeight: getData.inputHeight,
            };
            fs.writeFileSync(this.userDirectory, JSON.stringify(options));
            // fs.writeFile(
            //   this.userDirectory,
            //   JSON.stringify(options),
            //   function (err) {
            //     console.log(
            //       "index.vue  写入文件  options:",
            //       JSON.stringify(options)
            //     );
            //     if (err) {
            //       console.log("index.vue  写入文件 失败" + err);
            //       return;
            //     }
            //     console.log("index.vue 写入文件 It's saved!");
            //   }
            // );
          } catch (error) {
            console.log("index.vue 写入文件 It's error!", error);
          }
        }
        console.log("toLogin  response", response);
        var account = response.data.bearUser;
        console.log("messageBox id = ", account.id);
        this.addStation();
        var token = response.data.token;
        localStorage.setItem("token", token);
        localStorage.setItem("account", JSON.stringify(account));
        this.util.setLoginTip(1);
        this.getAuthorityRequest();
        this.successed();
      } else {
        this.$message.error(response.desc);
      }
    },

    ReSend() {
      this.getSMScode();
    },
    successed() {
      console.log("成功登录验证cookie---start：");
      let userAgent = navigator.userAgent.toLowerCase();
      if (!this.remember) {
        if (userAgent.indexOf("electron/") != -1) {
          const ipc = this.$electron.ipcRenderer;
          ipc.send("removeCookie", md5(this.name));
        } else {
          Cookies.remove(md5(this.name));
        }
      } else {
        if (userAgent.indexOf("electron/") != -1) {
          const ipc = this.$electron.ipcRenderer;
          let count = 0;
          console.log("cookie验证 electronCookies", this.electronCookies);
          for (let i = 0; i < this.electronCookies.length; i++) {
            let item = this.electronCookies[i];
            if (md5(this.name) == item.name) {
              console.log("cookie验证 item.value", item.value);
              console.log("cookie验证 this.passward", this.password);
              console.log("cookie验证 md5(passward)", md5(this.password));
              if (this.password == item.value) {
                count += 1;
              }
              break;
            }
          }
          if (count == 0) {
            console.log(
              "cookie验证  没有cookie 或者重新设置密码 重新设置cookie"
            );
            ipc.send("cookie", {
              name: md5(this.name),
              value: md5(this.password),
            });
          }
        }
      }
      console.log("成功登录验证cookie---end:");
      this.$router.push({
        path: "/home",
      });
    },
    async getSMScode() {
      var SMSapi = "/manager/user/pass/newUserSMS";
      return await this.util.postRequest({
        url: SMSapi,
        method: "POST",
        data: {
          loginName: this.name,
          password:
            this.loginType == "normal" ? md5(this.password) : this.password,
        },
      });
    },

    async getWechatQRcode() {
      // if(localStorage.getItem("QRcodeData")==null){

      // }else{
      // 	this.qrData = JSON.parse(localStorage.getItem("QRcodeData"))

      // }

      // 查询二维码
      var QRcodeapi = "/projectchat/weixin/getWechatQrCode";
      const response = await this.util.postRequest({
        url: QRcodeapi,
        method: "POST",
        data: {
          scene_str: this.station.replace(/\s/g, ""), //站点id
        },
        itype: "2",
      });
      this.qrData = response.data;
      console.log("QRcode", this.qrData);
      localStorage.setItem("QRcodeData", JSON.stringify(this.qrData));
      this.qrCodeTime = true;
      if (response.resultCode === "10000") {
        // this.getBindStatus()
        if (this.qrState != "") {
          clearInterval(this.qrState);
          this.qrState = "";
        }
        if (this.timer != "") {
          clearInterval(this.timer);
          this.timer = "";
        }
        this.timer = setInterval(this.setqrCodeTime, 300000); //300000 5分钟
        this.qrState = setInterval(this.getBindStatus, 1000);
      } else {
        this.$message.error(response.desc);
      }
    },
    inputLogin() {
      clearInterval(this.qrState);
      this.qrState = "";
      this.QRcode = false;
    },
    async wechatLogin() {
      // 微信登录按钮
      this.name = "";
      this.qrCodeTime = true;
      if (this.station === "") {
        const text = "站点不能为空";
        this.$message.error(text);
      } else {
        var api = "/projectchat/project/pass/selectByWebId";
        const response = await this.util.sitePostRequest({
          url: api,
          method: "POST",
          data: {
            webId: this.station.replace(/\s/g, ""),
          },
        });
        console.log("index confirm response = ", response);
        if (response.data !== null) {
          this.QRcode = true;
          var site = JSON.stringify(response.data);
          localStorage.setItem("siteObj", site);
          this.getWechatQRcode();
        } else {
          console.log("view index 站点验证失败");
          localStorage.removeItem("siteObj");
          this.$message.error(response.desc);
        }
      }
    },

    getCode() {
      if (this.name === "") {
        const text = "用户名不能为空";
        this.$message.error(text);
      } else if (this.password === "") {
        const text = "密码不能为空";
        this.$message.error(text);
      } else if (this.password.length < 6) {
        const text = "密码至少六位数";
        this.$message.error(text);
      } else {
        const TIME_COUNT = 59;
        this.getSMScode();
        if (!this.timers) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timers = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timers);
              this.timers = null;
            }
          }, 1000);
        }
      }
    },

    // async confirm(num) {
    // 	if (num == 1) {
    // 		if (this.station === "") {
    // 			const text = "站点不能为空"
    // 			this.$message.error(text)
    // 		} else if (this.name === "") {
    // 			const text = "用户名不能为空"
    // 			this.$message.error(text)
    // 		} else {
    // 			var api = '/projectchat/project/pass/selectByWebId';
    // 			const response = await this.util.sitePostRequest({
    // 				url: api,
    // 				method: 'POST',
    // 				data: {
    // 					webId: this.station.replace(/\s/g, "")
    // 				}
    // 			});
    // 			if (response.data !== null) {
    // 				//   sessionStorage.setItem("webUrl", response.data.webUrl);
    // 				//存储对象
    // 				var site = JSON.stringify(response.data);
    // 				localStorage.setItem('siteObj', site);
    // 				localStorage.setItem('username', JSON.stringify(this.name));
    // 				//登录
    // 				this.addStation()
    // 				this.toLogin();
    // 			} else {
    // 				localStorage.removeItem('siteObj');
    // 				this.$message.error(response.desc)
    // 			}
    // 		}

    // 	} else if (num == 2) {
    // 		var equNoApi = '/manager/equipment/evn/check'
    // 		const response = await this.util.postRequest({
    // 			url: equNoApi,
    // 			method: 'POST',
    // 			data: {
    // 				loginName: this.name
    // 			}
    // 		})
    // 		console.log("equNoApi response========", response)
    // 		if (response.resultCode == 10000) {
    // 			this.equNo = response.data.equNo
    // 		}
    // 		this.NewUser = false;
    // 		this.SetPassword = true;
    // 	} else if (num == 3) {
    // 		if (this.passwordChecked == true) {
    // 			this.SetPassword = false;
    // 			this.MessageCode = true;
    // 			this.getSMScode();
    // 		}
    // 	} else if (num == 4) {
    // 		this.MessageCode = false;
    // 		this.success = true;
    // 	}
    // },

    tipSureAction() {
      this.isShowTip = false;
    },

    close() {
      console.log("close");
      this.MessageCode = false;
    },

    confirmWebid(e) {
      // 处理输入登录名后enter键触发判断新老用户事件
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.confirm(1);
      }
    },
    nextUsername(e) {
      // 处理输入站点后enter键触发光标focus下一个input框用户名
      var keyCode = window.event ? e.keyCode : e.which;
      var inputs = document.getElementsByTagName("input");
      if (keyCode == 13) {
        inputs[1].focus();
      }
    },
    addStation(source) {
      console.log("index.vue  addStation:", this.name, this.station);
      let stations = [];
      const getStations = localStorage.getItem("stations");
      if (getStations) {
        stations = JSON.parse(getStations);
      }
      // 添加站点
      if (stations !=null && stations.length > 0) {
        if (stations.includes(this.station) == false) {
          stations.push(this.station);
          localStorage.setItem("stations", JSON.stringify(stations));
        }
      } else {
        localStorage.setItem("stations", JSON.stringify([this.station]));
      }
      var tempArr = JSON.parse(localStorage.getItem("stationsAndNames")) || [];
      // 多站点多账号
      if (tempArr.length > 0) {
        var stationIndex = tempArr.findIndex((item) => {
          return item.stationsOptions === this.station;
        });
        console.log(tempArr);
        if (stationIndex !== -1) {
          console.log(stationIndex);
          if (source === 0) {
            if (!tempArr[stationIndex].namesOptions.includes(this.username)) {
              tempArr[stationIndex].namesOptions.unshift(this.username);
            }
          } else {
            if (!tempArr[stationIndex].namesOptions.includes(this.name)) {
              tempArr[stationIndex].namesOptions.unshift(this.name);
            }
          }
        } else {
          tempArr.push({
            stationsOptions: this.station,
            namesOptions: [this.name],
          });
        }
      } else {
        tempArr.push({
          stationsOptions: this.station,
          namesOptions: [this.name],
        });
      }
      localStorage.setItem("stationsAndNames", JSON.stringify(tempArr));
    },


    delStation() {
      if(this.station == '') return;
      let stations = [];
      const getStations = localStorage.getItem("stations");
      if (getStations) {
        stations = JSON.parse(getStations);
      }
      // 添加站点
      if (stations !=null && stations.length > 0) {
        if (stations.includes(this.station) == true) {
          var index = stations.indexOf(this.station);
          if (index > -1) {
            stations.splice(index, 1);
          }
          localStorage.setItem("stations", JSON.stringify(stations));
        }
      } else {
        localStorage.setItem("stations", JSON.stringify([this.station]));
      }
      var tempArr = JSON.parse(localStorage.getItem("stationsAndNames")) || [];
      // 多站点多账号
      if (tempArr.length > 0) {
        var stationIndex = tempArr.findIndex((item) => {
          return item.stationsOptions === this.station;
        });
        console.log(tempArr);
        if (stationIndex !== -1) {
          tempArr.splice(stationIndex, 1);
        } 
      } 
      localStorage.setItem("stationsAndNames", JSON.stringify(tempArr));
      this.station = '';
      this.stationItems = stations;
      this.stationsAndNames = tempArr;
    },

    getStations() {
      const userAgent = navigator.userAgent.toLowerCase();
      let stations = [];

      // stations = JSON.parse(localStorage.getItem("stations"));
      if (userAgent.indexOf("electron/") != -1) {
        try {
          const data = this.$nodeFs.readFileSync(this.userDirectory, "utf-8");
          stations = JSON.parse(data).stations;
        } catch (error) {
          console.log("index.vue mounted error:", error);
        }
      } else {
        const getStations = localStorage.getItem("stations");
        if (getStations) {
          stations = JSON.parse(localStorage.getItem("stations"));
        }
      }

      this.stationItems = stations;
    },
    searchBlur(e) {
      this.station = e.target.value;
    },

    setqrCodeTime() {
      // localStorage.removeItem('QRcodeData')
      clearInterval(this.timer);
      clearInterval(this.qrState);
      this.timer = "";
      this.qrState = "";
      this.qrCodeTime = false;
    },
    refreshQRcode() {
      this.getWechatQRcode();
    },
    async getBindStatus() {
      // 查询扫码状态  0:未关注状态（即未扫码或扫码未关注）; 1:扫码关注未绑定;  2：已绑定
      var api = "/manager/weixin/getBindStatus/" + this.qrData.sceneStr;
      const response = await this.util.postRequest({
        url: api,
        method: "GET",
      });
      console.log("index getBindStatus response = ", response);
      this.qrResData = response.data;
      if (response.resultCode === "10000") {
        if (response.data.bindStatus === 0) {
          // 0: 未关注（即未扫码或扫码未关注）
          console.log("0: 未关注（即未扫码或扫码未关注）");
        } else if (response.data.bindStatus === 1) {
          //1: 扫码关注未绑定
          // clearInterval(this.timer)
          clearInterval(this.qrState);
          this.qrState = "";
          this.bind = true;
          console.log("扫码关注未绑定");
        } else if (response.data.bindStatus === 2) {
          // 2: 已绑定
          console.log("2: 已绑定");
          // clearInterval(this.timer)
          clearInterval(this.qrState);
          this.qrState = "";
          var token = response.data.loginData.token;
          var account = response.data.loginData.bearUser;
          localStorage.setItem("token", token);
          localStorage.setItem("account", JSON.stringify(account));
          this.$router.push("/home");
          this.util.setLoginTip(1);
          this.getAuthorityRequest();
        }
      } else {
        this.$message.error(response.desc);
      }
    },
    bindWeChat() {
      // 微信公众号绑定
      if (this.name === "") {
        const text = "用户名不能为空";
        this.$message.error(text);
      } else if (this.password === "") {
        const text = "密码不能为空";
        this.$message.error(text);
      } else if (this.password.length < 6) {
        const text = "密码至少六位数";
        this.$message.error(text);
      } else if (this.Vcode == "") {
        const text = "验证码不能为空";
        this.$message.error(text);
      } else {
        this.bindCsUser();
      }
    },
    async bindCsUser() {
      // 微信公众号绑定
      var api = "/manager/weixin/bindCsUser";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          webId: this.station.replace(/\s/g, ""),
          unionId: this.qrResData.unionId,
          sceneId: this.qrData.sceneStr,
          loginName: this.name,
          passward: this.password,
          captcha: this.Vcode,
        },
      });
      console.log("index bindCsUser response = ", response);
      if (response.resultCode === "10000") {
        var token = response.data.loginData.token;
        var account = response.data.loginData.bearUser;
        localStorage.setItem("token", token);
        localStorage.setItem("account", JSON.stringify(account));
        this.$message.success("绑定成功");
        this.addStation();
        this.$router.push("/home");
        this.util.setLoginTip(1);
        this.getAuthorityRequest();
      } else {
        this.$message.error(response.desc);
      }
    },
    async getAuthorityRequest() {
      var api = "/manager/permission/getPermissionList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("msgCodeBox getAuthorityRequest response = ", response);
      if (response.resultCode === "10000") {
        this.setDefaultSetting();
        var tempObj = this.util.getLocalPermintObj();
        for (var i = 0; i < response.data.length; i++) {
          const chatPermi = response.data[i];
          if (chatPermi.name === "对话管理") {
            const permiList = chatPermi.permiVoList;
            for (var j = 0; j < permiList.length; j++) {
              var permit = permiList[j];
              if (permit.name === "关闭会话") {
                tempObj.endChat = permit.status == 1 ? true : false;
              } else if (permit.name === "勿扰设置") {
                tempObj.disturb = permit.status == 1 ? true : false;
              } else if (permit.name === "转接会话") {
                tempObj.transter = permit.status == 1 ? true : false;
              } else if (permit.name === "打标签") {
                tempObj.markTag = permit.status == 1 ? true : false;
              } else if (permit.name === "添加黑名单") {
                tempObj.defriend = permit.status == 1 ? true : false;
              } else if (permit.name === "接管会话") {
                tempObj.adapter = permit.status == 1 ? true : false;
              } else if (permit.name === "我的同事") {
                tempObj.colleage = permit.status == 1 ? true : false;
              } else if (permit.name === "疑似骚扰用户") {
                tempObj.trouble = permit.status == 1 ? true : false;
              } else if (permit.name === "转接给他人") {
                tempObj.transterTa = permit.status == 1 ? true : false;
              } else if (permit.name == "在线访客列表") {
                tempObj.isOnlineList = permit.status == 1 ? true : false;
              } else if (permit.name == "同事快捷回复展现") {
                tempObj.quickShow = permit.status == 1 ? true : false;
              } else if (permit.name == "公共快捷回复展现") {
                tempObj.publicQuickShow = permit.status == 1 ? true : false;
              } else if (permit.name == "已离开（未结束）列表") {
                tempObj.isOnlineOffList = permit.status == 1 ? true : false;
              }
            }

          } else if (chatPermi.name === "个人设置") {
            tempObj.personPmtList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          } else if (chatPermi.name === "系统设置") {
            tempObj.systemPmtList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          } else if (chatPermi.name === "日志管理") {
            tempObj.log = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "留言管理") {
            tempObj.word = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "对话记录") {
            tempObj.record = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "开口机器人") {
            tempObj.bot = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "报表管理") {
            const permiList = chatPermi.permiVoList;
            for (var o = 0; o < permiList.length; o++) {
              var permit1 = permiList[o];
              if (permit1.name === "HTML报表下载") {
                tempObj.downHtml = permit1.status == 1 ? true : false;
              }
            }
          } else if (chatPermi.name === "Middleman管理") {
            tempObj.midmanPmtList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          } else if (chatPermi.name === "登录管理") {
            tempObj.loginmgList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          }
        }

        this.util.setLocalPermit(JSON.stringify(tempObj));
        // console.log("JSON.stringify(tempObj)", JSON.stringify(tempObj));
        this.$store.state.authority.isShowLog = this.util.getLocalPermit("log");
        this.$store.state.authority.isShowWord =
          this.util.getLocalPermit("word");
        this.$store.state.authority.isColleague =
          this.util.getLocalPermit("colleage");
        this.$store.state.authority.isTrouble =
          this.util.getLocalPermit("trouble");
        this.$store.state.authority.isEndChat =
          this.util.getLocalPermit("endChat");
        this.$store.state.authority.isTransfer =
          this.util.getLocalPermit("transter");
        this.$store.state.authority.isDefriend =
          this.util.getLocalPermit("defriend");
        this.$store.state.authority.isAdapter =
          this.util.getLocalPermit("adapter");
        this.$store.state.authority.isDisturb =
          this.util.getLocalPermit("disturb");
        this.$store.state.authority.isMarkTag =
          this.util.getLocalPermit("markTag");
        this.$store.state.authority.isShowBot = this.util.getLocalPermit("bot");
        this.$store.state.authority.isShowRecord =
          this.util.getLocalPermit("record");
        this.$store.state.authority.isOnlineList =
          this.util.getLocalPermit("isOnlineList");
        this.$store.state.authority.isOnlineOffList =
          this.util.getLocalPermit("isOnlineOffList");
        this.$store.state.authority.isQuickShow =
          this.util.getLocalPermit("quickShow");
          this.$store.state.authority.isPublicQuickShow =
          this.util.getLocalPermit("publicQuickShow");

        this.$store.state.authority.isTransferTa =
          this.util.getLocalPermit("transterTa");
        this.$store.state.authority.isDownHtml =
          this.util.getLocalPermit("downHtml");
        this.$store.state.authority.personList =
          this.util.getLocalPermit("personPmtList");
        this.$store.state.authority.systemList =
          this.util.getLocalPermit("systemPmtList");
        this.$store.state.authority.midmanList =
          this.util.getLocalPermit("midmanPmtList");
        this.$store.state.authority.loginmg =
          this.util.getLocalPermit("loginmgList");

        // this.$store.state.authority.systemList = this.util.getLocalPermit('systemPmtList')
      } else {
        this.$message.error(response.desc);
      }
    },
    setDefaultSetting() {
      console.log("msgCodeBox setDefaultSetting");
      var tempObj = {};
      tempObj.endChat = false;
      tempObj.disturb = false;
      tempObj.transter = false;
      tempObj.markTag = false;
      tempObj.defriend = false;
      tempObj.adapter = false;
      tempObj.colleage = false;
      tempObj.trouble = false;
      tempObj.personPmtList = [];
      tempObj.systemPmtList = [];
      // tempObj.systemPmtList = []
      tempObj.log = false;
      tempObj.word = false;
      tempObj.record = false;
      tempObj.bot = false;
      tempObj.transterTa = false;
      tempObj.downHtml = false;
      tempObj.quickShow = false;
      tempObj.publicQuickShow = false;

      this.util.setLocalPermit(JSON.stringify(tempObj));
    },

    //忘记密码
    async forgetpassword() {
      console.log("login forgetpassword");
      var api = "/manager/user/pass/getUserTel";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          loginName: this.name,
        },
      });
      console.log("forgetpassword: this.name", this.name);
      console.log("forgetpassword response:", response);
      if (response.resultCode === "10000") {
        console.log("index forgetpassword response =  成功");
        this.phoneNumber = response.data;
        this.setPassword = true;
        this.showCode = true;
      } else {
        console.log("index forgetpassword response =  失败");
        this.$message.error(response.desc);
      }
    },
    closeSet() {
      this.setPassword = false;
      this.showCode = false;
    },
    confirmSet(info) {
      console.log(info);
      if (info == 1) {
        this.setPassword = true;
        this.showPassword = true;
      } else if (info == 2) {
        this.setPassword = true;
        this.showPassword = true;
        this.showSuccess = true;
      } else {
        this.setPassword = false;
        this.showCode = false;
        this.showPassword = false;
        this.showSuccess = false;
      }
    },
    clickCancle(info) {
      if (info.type === "code") {
        this.setPassword = false;
        this.showCode = info.value;
      } else if (info.type === "password") {
        this.showPassword = info.value;
      } else if (info.type === "showSuccess") {
        this.showSuccess = info.value;
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  background-image: url(../../static/login/login_bg.jpg);

  .log_container {
    width: 1015px;
    height: 474px;
    background: #ffffff;
    box-shadow: 0px 7px 27px 0px rgba(133, 169, 231, 0.51);
    border-radius: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .log_container_left {
      border-radius: 20px 0px 0px 20px;
      width: 50%;
      height: 100%;
      // background-color: wheat;
      background-image: url(../../static/login/login_left.png);
      background-size: cover;
    }

    .log_container_right {
      width: 50%;
      height: 100%;
      background-color: white;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      border-radius: 0px 20px 20px 0px;

      .log_container_right_header {
        width: 100%;
        height: 94px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .imgs {
          cursor: pointer;
          position: absolute;
          right: 0;
          top: 0;
        }
      }

      .log_container_right_title {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        // line-height: 114px;
        // margin-top: 45px;
      }

      .log_selection :deep() {
        width: 442px;
        height: 50px;
        border: 1px solid #dcdcdc;
        border-radius: 2px;
        margin-top: 8px;

        .el-input {
          height: 100%;
        }

        .el-input__inner {
          border: none;
          height: 100%;
        }
      }

      .log_container_input :deep() {
        width: 442px;
        height: 50px;
        border: 1px solid #dcdcdc;
        border-radius: 2px;

        .el-input__inner {
          border: none;
          height: 100%;
        }

        // margin-top: 34px;
      }

      .input1 {
        margin-top: 8px;
      }

      .input2 {
        margin-top: 35px;
      }

      .log_button {
        width: 442px;
        height: 48px;
        margin-top: 26px;
        background: url(../../static/login/log_buuton.png);
        background-size: cover;
        cursor: pointer;
      }

      .log_container_right_footer {
        width: 442px;
        height: 18px;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .log_container_right_footer_left :deep() {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #333333;

          .el-checkbox__label {
            color: #333333 !important;
          }
        }

        .log_container_right_footer_right {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #1677d2;
          cursor: pointer;
        }
      }

      .qrcode {
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
      }
    }

    // margin: 50% 50%;
  }
  .filings {
    position: fixed;
    bottom: 20px;
    color: #666;
    a {
      color: inherit;
      &:hover {
        color: #000;
      }
    }
  }
}

/deep/ .weixin {
  display: flex;
  flex-direction: column;
  width: 443px;
  height: 474px;
  flex: 1;

  .el-input__inner {
    height: 46px;
  }

  .el-button {
    text-align: center;
    padding: 12px 0;
  }
}

input::-webkit-input-placeholder {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}

/deep/.el-select .el-input .el-select__caret::before {
  display: inline-block;
  content: "";
  width: 80%;
  height: 10px;
  background: url("../../static/login/login_up.png") no-repeat center
    center/cover;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */

  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */

  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}

input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */

  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
</style>
